/** See `src/i18n/locales/en/managePilots.ts`. */
export const managePilots = {
  page: {
    title: 'Pilotes',
    lead: 'Tous les pilotes de la plateforme, filtrables par entreprise et statut.',
    filterCompany: 'Entreprise',
    filterStatus: 'Statut',
    allCompanies: 'Toutes les entreprises',
    allStatuses: 'Tous les statuts',
    empty: 'Aucun pilote ne correspond à ces filtres.',
    rowsLabel: 'les pilotes',
    company: 'Entreprise',
    name: 'Nom',
    status: 'Statut',
    startDate: 'Date de début',
    endDate: 'Date de fin',
    departments: 'Départements',
  },
  status: {
    draft: 'Brouillon',
    baseline: 'Mesure initiale',
    active: 'Actif',
    interim_review: 'Évaluation intermédiaire',
    final_review: 'Évaluation finale',
    completed: 'Terminé',
    scaled: 'Déployé',
  },
} as const;
